import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'
import TwoFactorSetupForm from '@/auth/components/TwoFactorSetupForm.vue'
import TwoFactorSetupIntro from '@/auth/components/TwoFactorSetupIntro.vue'
import { useEventListener } from '@vueuse/core'
import TwoFactorSetupInfo from '@/auth/components/TwoFactorSetupInfo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorSetupPage',
  props: {
    hasUser: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  hasUser: boolean;
};



const authStore = useAuthStore()

const {
  page,
  userTwoFactorEnabled,
  twoFactorConfirmed,
  userCompletedTwoFactorAuth,
  navigationSteps
} = storeToRefs(authStore)

onBeforeMount(async () => {
  if (!props.hasUser) return window.location.href = '/'

  await authStore.checkTwoFactorAuthEnabled()

  if (userTwoFactorEnabled.value) {
    // Skip intro if 2FA is already enabled but not accepted
    if (!twoFactorConfirmed.value) return page.value = AuthPage.TWO_FACTOR_AUTH_INFO

    // Redirect to home if 2FA is already enabled
    return window.location.href = '/'
  }

  page.value = AuthPage.TWO_FACTOR_AUTH_INTRO
})

onMounted(() => {
  useEventListener(window, 'beforeunload', (e) => {
    if (!userCompletedTwoFactorAuth.value) {
      e.preventDefault()
    }
  })

  useEventListener(window, 'unload', () => {
    authStore.resetTwoFactorAuth()
  })
})

return { __sfc: true,props, authStore, page, userTwoFactorEnabled, twoFactorConfirmed, userCompletedTwoFactorAuth, navigationSteps, AuthPage, TwoFactorSetupForm, TwoFactorSetupIntro, TwoFactorSetupInfo }
}

})